import React from 'react';
import { content } from '../../content';
import { withPlural } from '../../utils/plural';
import '../../styles/Sections.css';

const { stack, ui } = content;

const StackSection = () => (
  <div className="section">
    <div className="stack-grid">
      {stack.groups.map((group) => (
        <section key={group.id} className="panel">
          <header className="panel__head">
            <h3 className="panel__title">{group.title}</h3>
            <p className="panel__caption">{group.caption}</p>
          </header>

          <ul className="stack-list">
            {group.items.map((item) => (
              <li key={item.name} className="stack-item">
                <div className="stack-item__head">
                  <span className="stack-item__name">{item.name}</span>
                  <span className="stack-item__count">
                    {withPlural(item.usedIn.length, ui.projectsPlural)}
                  </span>
                </div>
                <p className="stack-item__note">{item.note}</p>
                <ul className="stack-item__used">
                  {item.usedIn.map((project) => (
                    <li key={project} className="chip">
                      {project}
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  </div>
);

export default StackSection;
